import { axios_legacy as axios, axios as axios_new_api } from '@/store/config';
import { getMappedValue, getMappedContractValue } from '@/helpers/mapper';
import {filter, find, forEach} from 'lodash';
import { dataLayerPush } from '@/helpers/datalayer';

// import Vue from 'vue'
import { API_BASEURL } from '@/config';
import mockData from '../../../static/mockdata/errorreportstructure.json';

const subCategoryParams = (state) => (state.selectedCategoryType ? { type: state.selectedCategoryType } : {});


export default {
  state: () => ({
    errorReportStructure: null,
    currentCategories: null,
    currentSubCategories: null,
    subParts: null,
    laundryRooms: null,
    baseCategories: null,
    photos: [],
    activeErrorReports: [],
    archivedErrorReports: [],
    apartmentContracts: null,
    keyOptions: null,
    petOptions: null,
    // Platsen (t.ex. storagearea) som kategorierna hämtades för. Skickas med till subcategories så att API:t
    // vet vilka skadedjurskategorier som gäller, sessionen i API:t räcker inte (cookien skickas inte alltid).
    selectedCategoryType: null
  }),

  getters: {

    getErrorReportAreaByCode: (state) => {
      if (!state.currentCategories) return [];

      return state.currentCategories;
    },

    getErrorContractByRentalObjectCode: (state) => (rentalObjectCode) => {
      return state.apartmentContracts.find((c) => c.value == rentalObjectCode);
    },


    getErrorReportLocationByCodes: (state, getters) => (areaCode, locationCode) => {
      const area = getters.getErrorReportAreaByCode(areaCode);
      return area?.locations.find((l) => l.code === locationCode) || null;
    },

    getErrorReportAreas: (state) => {
      if (!state.currentCategories) return [];

      return state.currentCategories;
    },

    getBaseCategories: (state) => {
      if (!state.baseCategories) return [];
      return state.baseCategories;
    },

    getSubCategories: (state) => {
      if (!state.currentSubCategories) return [];
      return state.currentSubCategories;
    },
    getSubParts: (state) => {
      if (!state.subParts) return [];
      return state.subParts;
    },
    getLaundryRooms: (state) => {
      if (!state.laundryRooms) return [];
      return state.laundryRooms;
    },

    getPetOptions: (state) => {
      if (!state.petOptions) return [];
      return state.petOptions;
    },

    getKeyOptions: (state) => {
      if (!state.keyOptions) return [];
      return state.keyOptions;
    },

    getPhotos: (state) => {
      if (!state.photos) return [];
      return state.photos;
    },

    getApartmentContracts: (state) => {
      if (!state.apartmentContracts) return [];
      let temp = state.apartmentContracts;
      // temp.push(state.apartmentContracts[0]);
      return temp;
      //return [state.apartmentContracts[0]];
    },


    getUploadedPhotoById: (state) => (id) => state.photos.find((p) => p.id === id) || null,

    getErrorReportsList: (state) => state.activeErrorReports,
    getArchivedErrorReportsList: (state) => state.archivedErrorReports,
  },

  actions: {
    /*async fetchErrorReportStructure({ commit }) {
      try {
        const { data } = await axios.get('/workorders/options');
        commit('setErrorReportStructure', data);
      } catch (error) {
        console.error('Error fetching error report structure:', error);
        //commit('setErrorReportStructure', mockData); // Fallback to mock data
      }
    },*/
    async fetchBaseCategories({ commit, getters }, contracts) {
      try {
        const { data } = await axios_new_api.get(`/workorders/types`);
        if (data) {
          let base = [];
          forEach(data, (i) => {
            let mapped = getMappedContractValue(i.value);
            let ret = filter(contracts, (o) => mapped == o.rentalObjectType && i.name != null && i.name != "unknown" && (o.status != 'coming'));
            if (ret.length > 0) base.push(i);
          });

          commit('setBaseCategories', base);
        }
      } catch (error) {
        console.error('Error fetching base categories:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching base categories',
        });
      }
    },

    async fetchCategories({ commit }, { id, type }) {
      console.log("fetchCategories rooms!", id, type)
      commit('setCurrentCategories', null);
      commit('setSelectedCategoryType', type);

      try {
        let url = type != 'apartment' ? `/workorders/categories/${type}` : `/workorders/leases/apartment/${id}/rooms`;
        console.log("FETCH URL", url)
        const { data } = await axios_new_api.get(url);
//        const { data } = await axios_new_api.get(`/workorders/categories/${id}`);
        if (data) {
          console.log("set categories", JSON.parse(JSON.stringify(data)))
          commit('setCurrentCategories', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': '',
            'stepAndError': 'No rooms for ' + id + " " + type,
          });
        }
      } catch (error) {
        console.error('Error fetching active error reports:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching rooms for ' + id + " " + type,
        });
      }
    },

    clearCurrentCategories({commit}) {
      commit('setCurrentCategories', null);
      commit('setSelectedCategoryType', null);
    },
    clearSubCategories({commit}) {
      commit('setCurrentSubCategories', null);
    },
    clearSubParts({commit}) {
      commit('setSubParts', null);
    },
    clearApartmentContracts({commit}) {
      commit('setApartmentContracts', null);
    },
    clearLaundryRooms({commit}) {
      commit('setLaundryRooms', null);
    },

    async fetchSubCategories({ commit }, id) {
      console.log("fetchSubCategories for roomtype!", id)
      commit('setCurrentSubCategories', null);
      try {
        const { data } = await axios_new_api.get(`/workorders/categories/rooms/${id}`);
        if (data) {
          console.log("setCurrentSubCategories for ",id, ": ", data)
          commit('setCurrentSubCategories', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': '',
            'stepAndError': 'No subcategories for roomtype ' + id,
          });
        }
      } catch (error) {
        console.error('Error fetching active error reports:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching subcategories for roomtype ' + id,
        });
      }
    },
    async fetchLaundryRooms({ commit },  { id, type }) {
      console.log("fetch laundry / playgrounds!", id)
      commit('setLaundryRooms', null);
      commit('setSelectedCategoryType', type);
      try {
        let url = type == 'laundryroom' ? `/workorders/leases/apartment/${id}/laundryrooms` : `/workorders/leases/apartment/${id}/playgrounds`;
        console.log("laundry rooms / playgrounds for ",url)
        const { data } = await axios_new_api.get(url);

        if (data) {
          commit('setLaundryRooms', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': 'Steg 1.3 - Var är felet? - ' + (type === 'laundryroom' ? 'Tvättstuga' : 'Lekplats'),
            'stepAndError': 'No laundryrooms or playgrounds found for ' + (type === 'laundryroom' ? 'Tvättstuga' : 'Lekplats'),
          });
        }
      } catch (error) {
        console.error('Error fetching active error reports:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': 'Steg 1.3 - Var är felet? - ' + (type === 'laundryroom' ? 'Tvättstuga' : 'Lekplats'),
          'stepAndError': 'Error fetching laundryrooms or playgrounds for ' + (type === 'laundryroom' ? 'Tvättstuga' : 'Lekplats'),
        });
      }
    },

    async fetchPetOptions({ commit }) {
      try {
        const { data } = await axios_new_api.get('/workorders/categories/pets');
        if (data) {
          commit('setPetOptions', data);
          return data;
        }
        else {
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': 'Steg 5 - Tillträde',
            'stepAndError': 'No pet options found',
          });
        }
      } catch (error) {
        console.error('Error fetching pet options:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': 'Steg 5 - Tillträde',
          'stepAndError': 'Error fetching pet options',
        });
      }
    },

    async fetchKeyOptions({commit}) {
      try {
        const {data} = await axios_new_api.get('/workorders/categories/keys');
        if (data) {
          commit('setKeyOptions', data);
          return data;
        }
        else {
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': 'Steg 5 - Tillträde',
            'stepAndError': 'No key options found',
          });
        }

      } catch (error) {
        console.error('Error fetching key options:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': 'Steg 5 - Tillträde',
          'stepAndError': 'Error fetching key options',
        });
      }
    },


    async fetchApartmentContracts({ commit }, id) {
      // Nytt platsval, platsen sätts igen när kategorierna hämtas
      commit('setSelectedCategoryType', null);
      let type = getMappedContractValue(id);
      console.log("fetch contracts of type ", id, " mappedType", type)
      if (type == "premise") type = 'rentedStorageArea';

      try {
        const { data } = await axios_new_api.get(`/workorders/leases/${type}`);
        if (data) {
          console.log("contracts: ", data)
          commit('setApartmentContracts', data);
          return data;
        }
        else {
          console.log("nothing")
        }
      } catch (error) {
        console.error(error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching apartment contracts for ' + id,
        });
      }
    },

    async fetchPartsOutside({ commit, state }, id) {
      console.log("--fetchSubPartsOutside", id)
      try {
        const { data } = await axios_new_api.get(`/workorders/categories/${id}/subcategories`, { params: subCategoryParams(state) });
        if (data) {
          console.log("setPartsOutside for ", id, ": ", data)
          commit('setPartsOutside', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': '',
            'stepAndError': 'No subcategories found for ' + id,
          });
        }
      } catch (error) {
        console.error('Error fetching active error reports:', error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching subcategories ' + id,
        });
      }
    },

    async fetchSubParts({ commit, state }, id) {
      console.log("fetchSubParts!", id)
      try {
        const { data } = await axios_new_api.get(`/workorders/categories/${id}/subcategories`, { params: subCategoryParams(state) });
        if (data) {
          console.log("setSubParts for ", id, ": ", data)
          commit('setSubParts', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': '',
            'stepAndError': 'No subcategories found for ' + id,
          });
        }
      } catch (error) {
        console.error(error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching subcategories ' + id,
        });
      }
    },

    async fetchPestControlCategories({ commit }, { mainCategoryId, leaseId, roomId }) {
      console.log("fetchPestControlCategories!", mainCategoryId, leaseId, roomId)
      try {
        const { data } = await axios_new_api.get(`/workorders/categories/${mainCategoryId}/${leaseId}/${roomId}/subcategories`);
        if (data) {
          console.log("setPestControlCategories for ", mainCategoryId, leaseId, roomId, ": ", data)
          commit('setSubParts', data);
          return data;
        }
        else {
          console.log("nothing")
          dataLayerPush({
            'event': 'serviceRequestErrorMessage',
            'issueLocationAndCategory': '',
            'stepAndError': 'No pest control categories found for room',
          });
        }
      } catch (error) {
        console.error(error);
        dataLayerPush({
          'event': 'serviceRequestErrorMessage',
          'issueLocationAndCategory': '',
          'stepAndError': 'Error fetching pest control categories',
        });
      }
    },


    uploadPhoto({ commit, state }, base64) {
      // Skapa ett unikt ID för bilden (t.ex. timestamp)
      const id = Date.now().toString();

      // Skapa ett photo-objekt
      const photoData = {
        id,
        url: base64, // base64-data
      };

      // Spara i state via mutation
      commit('pushPhotos', photoData);

      // Returnera promise med photo-data
      return Promise.resolve(photoData);
    },
    fetchUploadedPhoto({ state }, img) {
      // Leta efter bilden i state.photos
      const photo = state.photos.find(p => p.id === img.id);
      // Returnera en promise så det kan användas async
      return Promise.resolve(photo);
    },



    async fetchErrorReportsList({ commit }, contactCode) {
      try {
        const { data } = await axios_new_api.get(`/workorders`);
        if (data) {
          const reversedData = [...data].reverse();
          const reports = {
            workorders: reversedData.filter((c) => (c.status !== "finished")) || []// && c.status !== "finished")) || []
          };

          const archivedreports = {
            workorders: reversedData.filter((c) => (c.status === "finished")) || []// && c.status !== "finished")) || []
          };


          commit('setActiveErrorReport', reports);
          commit('setArchivedErrorReport', archivedreports);
        }
        else {
          commit('setActiveErrorReport', data);
        }
      } catch (error) {
        console.error('Error fetching active error reports:', error);
      }
    },

    async fetchArchivedErrorReportsList({ commit }, contactCode) {
      try {
        const { data } = await axios.get(`/applicants/${contactCode}/workorders/archive`);
        commit('setArchivedErrorReport', data);
      } catch (error) {
        console.error('Error fetching archived error reports:', error);
      }
    },

    async fetchErrorReportsDetails({ commit }, workOrderCode) {
      try {
        const { data } = await axios.get(`/workorders/${workOrderCode}`);
        commit('setErrorReportDetails', data);
      } catch (error) {
        console.error('Error fetching error report details:', error);
      }
    },

    async fetchArchivedErrorReportDetails({ commit }, workOrderCode) {
      try {
        const { data } = await axios.get(`/workorders/${workOrderCode}`);
        commit('setArchivedErrorReportDetails', data);
      } catch (error) {
        console.error('Error fetching archived error report details:', error);
      }
    },

    async updateErrorReportsDetails({ commit }, workOrderCode) {
      try {
        const { data } = await axios.get(`/workorders/${workOrderCode}?readMode=ReadFromOrigin`);
        data.lastUpdatedDate = data.lastUpdatedDate || data.lastUpdateDate; // Handle API typo
        commit('setErrorReportDetails', data);
      } catch (error) {
        console.error('Error updating error report details:', error);
      }
    },
  },

  mutations: {
    setSelectedCategoryType(state, type) {
      state.selectedCategoryType = type || null;
    },
    setErrorReportStructure(state, data) {
      state.errorReportStructure = data;
    },

    setCurrentCategories(state, data) {
      state.currentCategories = data;
    },

    setCurrentSubCategories(state, data) {
      state.currentSubCategories = data;
    },
    setSubParts(state, data) {
      state.subParts = data;
    },

    setPartsOutside(state, data) {
      state.currentSubCategories = data;
    },

    setApartmentContracts(state, data) {
      state.apartmentContracts = data;
    },

    setKeyOptions(state, data) {
      state.keyOptions = data;
    },

    setLaundryRooms(state, data) {
      state.laundryRooms = data;
    },

    setPetOptions(state, data) {
      state.petOptions = data;
    },

    setBaseCategories(state, data) {
      state.baseCategories = data;
    },

    setActiveErrorReport(state, data) {
      data.workorders
        .sort((b, a) => new Date(a.registeredDate) - new Date(b.registeredDate))
        .forEach((i) => {
          i.title = i.title
            .replace('Från webb: ', '')
            .replace('Webb: ', '')
            .replace(/,\s*$/, '')
            .replace(',', ' >');
        });

      state.activeErrorReports = data;
    },

    setArchivedErrorReport(state, data) {
      if (data?.workorders) {
        data.workorders.sort((a, b) => new Date(b.finishedDate) - new Date(a.finishedDate));
      }
      state.archivedErrorReports = data;
    },

    setErrorReportDetails(state, data) {
      const workorder = find(state.activeErrorReports.workorders, ['code', data.code]);
      if (workorder) workorder.details = data;
    },

    setArchivedErrorReportDetails(state, data) {
      const workorder = find(state.archivedErrorReports.workorders, ['code', data.code]);
      if (workorder) workorder.details = data;
    },

    pushPhotos(state, data) {
      state.photos.push(data);
    },
  },
};
